import { queryOptions } from "@tanstack/react-query";
import { api, unwrap } from "@/client/lib/api";
import { noteRead } from "@/client/lib/sync-cursor";
import type { InboxItem } from "@/features/inbox/schemas";

/** Newest first, read and unread; the tabs and the Show menu filter it in memory. */
export const inboxQuery = queryOptions({
  queryKey: ["inbox"],
  queryFn: async ({ client }): Promise<InboxItem[]> => {
    const { items, cursor } = await unwrap(api.inbox.$get());
    noteRead(client, cursor);
    return items;
  },
});
